import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const SSOCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('Procesando inicio de sesión con Microsoft...');
  const [error, setError] = useState(null);

  useEffect(() => {
    const ssoToken = searchParams.get('sso_token');
    const ssoUserId = searchParams.get('sso_user_id');
    const ssoError = searchParams.get('sso_error');

    if (ssoError) {
      setError(decodeURIComponent(ssoError));
      setTimeout(() => { window.location.href = '/login'; }, 3000);
      return;
    }

    if (!ssoToken) {
      setError('No se recibió token de autenticación');
      setTimeout(() => { window.location.href = '/login'; }, 2000);
      return;
    }

    // Clear ALL old auth data first
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    
    // Store new token and fetch user data
    localStorage.setItem('token', ssoToken);
    setStatus('Obteniendo datos del usuario...');

    fetch(`${API_URL}/api/auth/me`, {
      headers: { Authorization: `Bearer ${ssoToken}` }
    })
      .then(r => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then(userData => {
        localStorage.setItem('user', JSON.stringify(userData));
        setStatus('¡Inicio de sesión exitoso! Redirigiendo...');
        window.location.href = '/dashboard';
      })
      .catch(err => {
        console.error('SSO callback error:', err);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setError(`Error al validar sesión: ${err.message}`);
        setTimeout(() => { window.location.href = '/login'; }, 3000);
      });
  }, []); // Run only once on mount

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0a0a0f', color: '#fff' }}>
      <div style={{ textAlign: 'center', maxWidth: '400px', padding: '2rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', marginBottom: '1.5rem' }}>
          <svg style={{ height: '32px', width: '32px' }} viewBox="0 0 21 21" fill="none">
            <rect x="1" y="1" width="9" height="9" fill="#F25022"/>
            <rect x="11" y="1" width="9" height="9" fill="#7FBA00"/>
            <rect x="1" y="11" width="9" height="9" fill="#00A4EF"/>
            <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
          </svg>
          <span style={{ fontSize: '1.25rem', fontWeight: '600' }}>Microsoft SSO</span>
        </div>
        
        {error ? (
          <div>
            <p style={{ color: '#f87171', fontWeight: '500', marginBottom: '0.5rem' }}>{error}</p>
            <p style={{ fontSize: '0.875rem', color: '#9ca3af' }}>Redirigiendo al inicio de sesión...</p>
          </div>
        ) : (
          <div>
            <div style={{ 
              border: '3px solid transparent',
              borderTopColor: '#3b82f6',
              borderRadius: '50%',
              width: '32px',
              height: '32px',
              animation: 'spin 1s linear infinite',
              margin: '0 auto 1rem'
            }}></div>
            <p style={{ color: '#9ca3af' }}>{status}</p>
          </div>
        )}
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default SSOCallbackPage;
